import React from 'react';

interface FormStepProps {
  children: React.ReactNode;
  className?: string;
}

export const FormStep: React.FC<FormStepProps> = ({ 
  children, 
  className = 'space-y-3' 
}) => {
  return (
    <div className={className}>
      {children}
    </div>
  );
};